import React, { useEffect, useState } from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import './App.css';

export default function Editreceipt(){

    const [rdetail, setRdetail] = useState([]);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const navigate = useNavigate();
    const [account, setAccount] = useState([]);
    const [finddue,setFinddue] = useState([]);
    const APP_NAME = process.env.REACT_APP_NAME;

    function sleep(ms) 
    {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
useEffect(()=>
{
    fetch(API_URL+"api/Ledger/GetAccounts")
    .then(response => response.json())
    .then(data => {setAccount(data)});
    
},[])

function loandetails()
{
    if(rdetail.length > 0)
    {
    document.getElementById("idNum").value = rdetail[0].CustomerName;
    document.getElementById("loNum").value = rdetail[0].LoanNo;
    document.getElementById("loBal").value= rdetail[0].RBalance;
    document.getElementById("doPay").value = rdetail[0].RDate.slice(8,10)+"-"+rdetail[0].RDate.slice(5,7)+"-"+rdetail[0].RDate.slice(0,4);
    document.getElementById("loPay").value = rdetail[0].RAmount;
    document.getElementById("fine").value = rdetail[0].RFine;
    }
}

function receiptdetail()
{
     fetch(API_URL+"api/Delete/ReceiptDetail?id="+document.getElementById("billno").value).then(res=>res.json())
    .then((data)=>{setRdetail(data)});
}
    
    console.log(rdetail);

function deletereceipt()
{


    fetch(API_URL+"api/Delete/DeleteReceipt?id="+ rdetail[0].ReceiptNo,{method:"put",body:null})
    .then(response => response.json())
    .then(() =>{});

    fetch(API_URL+"api/Delete/DeleteFine?id="+ rdetail[0].ReceiptNo,{method:"put",body:null})
    .then(response => response.json())
    .then(() =>{});

    
    const cashaccount = account.filter((e)=>{if(e.AccountID === 3){return e;}})
    const loanaccount = account.filter((e)=>{if(e.AccountID === 4){return e;}})
    const fineaccount = account.filter((e)=>{if(e.AccountID === 6){return e;}})

    fetch(API_URL+"api/Payment/GetPayments?id="+rdetail[0].LoanNo)
    .then(response => response.json())
    .then((data) => {setFinddue(data)});

    fetch(API_URL+"api/Ledger/DeleteAccountLedgerEntry?id="+ rdetail[0].CommonID,{method:"put",body:null})
    .then(response => response.json())
    .then(() =>{});

    fetch(API_URL+"api/Ledger/DeleteLoanLedgerEntry?id="+ rdetail[0].CommonID,{method:"put",body:null})
    .then(response => response.json())
    .then(() =>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentDebit?id="+cashaccount[0].AccountID+"&amount="+(cashaccount[0].CurrentDebit-rdetail[0].RAmount-rdetail[0].RFine) ,{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+loanaccount[0].AccountID+"&amount="+(loanaccount[0].CurrentCredit-rdetail[0].RAmount),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    fetch(API_URL+"api/Ledger/UpdateCurrentCredit?id="+fineaccount[0].AccountID+"&amount="+ (fineaccount[0].CurrentCredit-rdetail[0].RFine),{method:"PUT",body:null})
    .then(response => response.json())
    .then(()=>{});

    
    showOKdialog();

}

function showOKdialog()
{
  const dialog = document.getElementById('myDialog');
  dialog.showModal();
}

function loanupdate()
{
      
    if(finddue.length > 0)
    {
        fetch(API_URL+"api/Delete/Loanupdate?id="+ rdetail[0].LoanNo,{method:"put",body:null})
        .then(response => response.json())
        .then(() =>{});
    }
    else
    {
        fetch(API_URL+"api/Loan/LoanUpdateForReceiptDelete?loanid="+ rdetail[0].LoanNo,{method:"put",body:null})
        .then(response => response.json())
        .then(() =>{});
    }

}

    return(
        <>
        <div style = {{height:"100%", width:"100%"}}>
            <div style={{ width:"100%",height:"40px",paddingLeft:"10px" ,
            backgroundColor:"blue", color:"white",textAlign:"left",fontSize:"25px"}}>{APP_NAME}</div>
            <div style={{ width:"100%",height:"30px",paddingLeft:"10px" ,
            backgroundColor:"goldenrod", color:"white",textAlign:"center",fontSize:"20px"}}>Delete Receipt </div>
            <Navbar/>
            <label for ="billno" style={{marginLeft:"20px"}}>Receipt No</label>
            <input id ="billno" style = {{height:"30px",width:"40%",marginLeft:"10px"}} onChange={()=>{receiptdetail()}}></input> 
            <button type = "button"  style ={{height:"34px",width:"20%",marginLeft:"22px",marginTop:"10px",backgroundColor:"orange", color:"white",fontSize:"14px",fontWeight:"bolder", borderRadius:"5px"}} onClick={()=>{loandetails()}} >Search</button>

            <fieldset style={{marginTop:"10px"}}>
                <legend>Receipt Info</legend>
            <label for = "idNum">Customer</label><br />
            <input type = "text"  id = "idNum" className='inputfield'  ></input><br/> <br/>
            
            
            <label for ="loNum">Loan Number</label><br/>
            <input type = 'text' id ='loNum' className='inputfield'></input><br/><br/>
            
            <label for ="loBal">Balance</label><br/>
            <input type = 'text' id ='loBal' className='inputfield'></input><br/><br/>
            
            <label for = 'doPay'>Date Of Payment </label><br/>
            <input id = 'doPay'  type = "text"  className='inputfield'/><br/><br/>
            
            <label for ="loPay">Paying Amount </label><br/>
            <input type = 'text' id ='loPay'  className='inputfield'></input><br/><br/>
            
            <label for ="fine">Fine Amount </label><br/>
            <input type = 'text' id ='fine' className='inputfield'></input><br/>
            </fieldset>
            <div>
            <button type = "button"  className="actionbuttons" onClick={()=>{deletereceipt()}}>Delete</button>
            <button type = "button"  className="actionbuttons" style ={{backgroundColor:"red"}} onClick={()=>{navigate('/changes')}}>Cancel</button>
            </div>
            </div>

            <dialog id="myDialog" className="okdialog"><p>Receipt Deleted</p>
            <button className="okdialogbutton" onClick={()=>{loanupdate();navigate('/changes');}}>OK</button>
            </dialog> 
        </>
    )
}